// extracted by mini-css-extract-plugin
export var actionButton = "_rl-0";
export var actionMenuContainer = "_rl-i";
export var bubble = "_rl-2";
export var bubbleActionMenu = "_rl-j";
export var bubbleContext = "_rl-6";
export var bubbleItems = "_rl-7";
export var customer = "_rl-3";
export var divider = "_rl-8";
export var fileList = "_rl-9";
export var hiddenComment = "_rl-o";
export var infoAbove = "_rl-a";
export var internal = "_rl-4";
export var lightActionButton = "_rl-1";
export var link = "_rl-b";
export var merchant = "_rl-5";
export var message = "_rl-c";
export var profilePicture = "_rl-e";
export var quillToolbarContainer = "_rl-f";
export var senderDate = "_rl-g";
export var senderDateCustomer = "_rl-h";
export var senderName = "_rl-d";
export var time = "_rl-k";
export var uploadedImage = "_rl-l";
export var username = "_rl-m";
export var xsmall = "_rl-n";